
class $d6f89a2e975a62e2$export$f43653f9482b7473 {
    // TODO: remove optional from version 1.0.0
    constructor(options){
        this.canvasWidth = 0;
        this.canvasHeight = 0;
        // image related variables
        this.fit = true;
        this.baseScale = 1;
        this.maxScale = 5;
        this.minScale = 1;
        this.onResize = this.debounce(()=>{
            if (!this.img) return;
            const deltaX = this.canvas.offsetWidth - this.canvasWidth;
            const deltaY = this.canvas.offsetHeight - this.canvasHeight;
            this.canvasWidth = this.canvas.width = this.canvas.offsetWidth;
            this.canvasHeight = this.canvas.height = this.canvas.offsetHeight;
            if (this.fit && this.imgWidth < this.canvasWidth) {
                this.netPanningX = 0;
                this.onImageLoad();
            } else if (this.fit && this.imgHeight < this.canvasHeight) {
                this.netPanningY = 0;
                this.onImageLoad();
            } else {
                this.netPanningX += deltaX / 2;
                this.netPanningY += deltaY / 2;
                this.originalWidth = this.canvasWidth;
                this.originalHeight = this.canvasWidth * this.ratio;
                this.draw();
            }
            this.fixScale();
        }, 300);
        this.baseScale = options?.baseScale || this.baseScale;
        this.maxScale = options?.maxScale || this.maxScale;
        this.minScale = options?.minScale || this.minScale;
        this.loadCanvas(options?.canvas || document.createElement('canvas'), options?.width, options?.height);
        if (options?.rangeInput) this.loadSlider(options.rangeInput);
        if (options?.imageUrl) this.loadImageFromUrl(options?.imageUrl, options?.fit, ()=>{
            this.move(options?.x || 0, options?.y || 0);
            options?.onImageLoad?.();
        });
    }
    // define function to clamp number
    clamp(num, from, to) {
        return Math.max(from, Math.min(num, to));
    }
    // define debounce function
    debounce(func, timeout) {
        let timer;
        return (...args)=>{
            clearTimeout(timer);
            timer = setTimeout(()=>{
                func(...args);
            }, timeout);
        };
    }
    // initialize pointer related variables
    initPointerAndZoom() {
        this.isDown = false;
        this.netPanningX = 0;
        this.netPanningY = 0;
        this.eventCache = [];
        this.prevDiff = -1;
        if (this.slider) this.slider.value = String(this.baseScale);
    }
    // draw image
    draw() {
        if (!this.img) return;
        this.canvasContext?.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        this.canvasContext?.drawImage(this.img, this.netPanningX, this.netPanningY, this.imgWidth, this.imgHeight);
    }
    // fix range
    fixScale() {
        if (this.fit) this.scale = Math.min(this.imgWidth / this.canvasWidth, this.imgHeight / this.canvasHeight) || this.baseScale;
        else this.scale = Math.min(this.imgWidth / this.originalWidth, this.imgHeight / this.originalHeight) || this.baseScale;
        if (this.slider) this.slider.value = String(this.scale);
    }
    // recalculate images related variables
    onImageLoad() {
        if (this.fit) {
            this.scale = Math.max(this.canvasHeight / this.imgHeight, this.canvasWidth / this.imgWidth);
            this.imgHeight *= this.scale;
            this.imgWidth *= this.scale;
        }
        this.pointerX = this.pointerY = 0;
        this.originalWidth = this.imgWidth;
        this.originalHeight = this.imgHeight;
        this.ratio = this.originalHeight / this.originalWidth;
        this.draw();
    }
    // get the median point of pointers
    getPointerAverage() {
        let x = 0;
        let y = 0;
        for(let i = 0; i < this.eventCache.length; i++){
            x += this.eventCache[i].offsetX;
            y += this.eventCache[i].offsetY;
        }
        x = x / this.eventCache.length;
        y = y / this.eventCache.length;
        return [
            x,
            y
        ];
    }
    // calc origin for zoom and pinch
    calcOrigin(x, y) {
        this.originX = (-this.netPanningX + x) / this.imgWidth;
        this.originY = (-this.netPanningY + y) / this.imgHeight;
    }
    move(x, y) {
        // the last mousemove event
        const dx = x - this.pointerX;
        const dy = y - this.pointerY;
        // reset the vars for next mousemove
        this.pointerX = x;
        this.pointerY = y;
        // accumulate the net panning done
        this.netPanningX = this.fit ? this.clamp(this.netPanningX + dx, this.canvasWidth - this.imgWidth, 0) : this.netPanningX + dx;
        this.netPanningY = this.fit ? this.clamp(this.netPanningY + dy, this.canvasHeight - this.imgHeight, 0) : this.netPanningY + dy;
    }
    drawZoom(deltaX, deltaY) {
        this.netPanningX = this.fit ? this.clamp(this.netPanningX - deltaX * this.originX, this.canvasWidth - this.imgWidth, 0) : this.netPanningX - deltaX * this.originX;
        this.netPanningY = this.fit ? this.clamp(this.netPanningY - deltaY * this.originY, this.canvasHeight - this.imgHeight, 0) : this.netPanningY - deltaY * this.originY;
    }
    zoomDelta(deltaX, deltaY) {
        const newWidth = this.imgWidth + deltaX;
        if (newWidth < this.originalWidth || this.imgHeight + deltaY < this.originalHeight) return;
        if (newWidth / this.originalWidth > this.maxScale || newWidth / this.originalWidth < this.minScale) return;
        if (this.slider) this.slider.value = String(this.scale = newWidth / this.originalWidth) // TODO: check
        ;
        // calc new size
        this.imgWidth = newWidth;
        this.imgHeight += deltaY;
        // accumulate the net panning done
        this.drawZoom(deltaX, deltaY);
    }
    zoomScale(scale) {
        if (scale > this.maxScale || scale < this.minScale) return;
        this.prevDiff = -1;
        let deltaX = this.imgWidth;
        let deltaY = this.imgHeight;
        // calc new size
        this.imgWidth = this.originalWidth * scale;
        this.imgHeight = this.originalHeight * scale;
        // calc diff
        deltaX -= this.imgWidth;
        deltaY -= this.imgHeight;
        //
        this.calcOrigin(this.canvasWidth / 2, this.canvasHeight / 2);
        this.drawZoom(-deltaX, -deltaY);
    }
    pinch() {
        if (this.eventCache.length === 2) {
            // Calculate the distance between the two pointers
            const curDiff = Math.hypot(this.eventCache[0].offsetX - this.eventCache[1].offsetX, this.eventCache[0].offsetY - this.eventCache[1].offsetY);
            // zoom into image
            if (this.prevDiff > 0) {
                const delta = curDiff - this.prevDiff;
                this.zoomDelta(delta, delta * this.ratio);
            }
            this.prevDiff = curDiff;
        }
    }
    /* -------------------------------------------------------------------------- */ /*                               Event Handlers                               */ /* -------------------------------------------------------------------------- */ onSliderMove(e) {
        const value = e.target.value;
        this.scale = +value;
        this.zoomScale(this.scale);
        this.draw();
    }
    onPointerdown(e) {
        if (!this.img) return;
        // This event is cached to support 2-finger gestures
        this.eventCache.push(e);
        // refresh move origin
        [this.pointerX, this.pointerY] = this.getPointerAverage();
        this.isDown = true;
    }
    onPointerUp(e) {
        if (!this.isDown) return;
        // If the number of pointers down is less than two then reset diff tracker
        this.eventCache = this.eventCache.filter((ev)=>ev.pointerId !== e.pointerId);
        if (this.eventCache.length < 2) this.prevDiff = -1;
        [this.pointerX, this.pointerY] = this.getPointerAverage();
        if (this.eventCache.length === 0) this.isDown = false;
    }
    onPointermove(e) {
        if (!this.isDown) return;
        // Find this event in the cache and update its record with this event
        for(let i = 0; i < this.eventCache.length; i++)if (e.pointerId === this.eventCache[i].pointerId) {
            this.eventCache[i] = e;
            break;
        }
        // calc x,y and
        const [x, y] = this.getPointerAverage();
        this.move(x, y);
        this.pinch();
        this.calcOrigin(this.canvasWidth / 2, this.canvasHeight / 2);
        this.draw();
    }
    prevent(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    leadListeners() {
        this.canvas.addEventListener('pointerdown', (e)=>{
            this.prevent(e);
            this.onPointerdown(e);
        });
        this.canvas.addEventListener('pointermove', (e)=>{
            this.prevent(e);
            this.onPointermove(e);
        });
        this.canvas.addEventListener('pointerout', (e)=>{
            this.prevent(e);
            this.onPointerUp(e);
        });
        this.canvas.addEventListener('pointerup', (e)=>{
            this.prevent(e);
            this.onPointerUp(e);
        });
        this.canvas.addEventListener('pointercancel', (e)=>{
            this.prevent(e);
            this.onPointerUp(e);
        });
        this.canvas.addEventListener('pointerleave', (e)=>{
            this.prevent(e);
            this.onPointerUp(e);
        });
        new ResizeObserver(this.onResize).observe(this.canvas);
    }
    /* -------------------------------------------------------------------------- */ /*                                   Loading                                  */ /* -------------------------------------------------------------------------- */ loadSlider(el) {
        this.slider = el;
        this.slider.value = String(this.scale || this.baseScale);
        this.slider.addEventListener('input', (e)=>{
            this.prevent(e);
            this.onSliderMove(e);
        });
    }
    loadCanvas(el, width, height) {
        this.canvas = el;
        const context = this.canvas.getContext('2d');
        if (!context) throw Error('could not get a 2d canvas context');
        this.canvasContext = context;
        this.canvasWidth = this.canvas.width = width || this.canvas.offsetWidth;
        this.canvasHeight = this.canvas.height = height || this.canvas.offsetHeight;
        this.leadListeners();
    }
    loadImageFromUrl(url, fitImage = true, onload) {
        if (!this.canvas) throw Error('first call loadCanvas');
        this.fit = fitImage;
        this.img = new Image();
        this.img.onload = ()=>{
            this.initPointerAndZoom();
            this.imgHeight = this.img.naturalHeight;
            this.imgWidth = this.img.naturalWidth;
            this.onImageLoad();
            onload?.();
        };
        this.img.src = url;
    }
    /* -------------------------------------------------------------------------- */ /*                                   Export                                   */ /* -------------------------------------------------------------------------- */ getCanvas(scale) {
        if (!this.img) throw Error('please set an image');
        const canvas = document.createElement('canvas');
        canvas.width = this.canvasWidth * scale;
        canvas.height = this.canvasHeight * scale;
        const context = canvas.getContext('2d');
        if (!context) throw Error('could not get a 2d canvas context');
        context.drawImage(this.img, this.netPanningX * scale, this.netPanningY * scale, this.imgWidth * scale, this.imgHeight * scale);
        return canvas;
    }
    getBlob(scale = 1) {
        return new Promise((resolve, reject)=>{
            this.getCanvas(scale).toBlob((blob)=>{
                if (blob) resolve(blob);
                else reject(Error('could not create blob from canvas'));
            });
        });
    }
    getDataUrl(scale = 1) {
        return this.getCanvas(scale).toDataURL();
    }
    download(scale = 1) {
        const link = document.createElement('a');
        link.download = 'canvas.png';
        link.href = this.getDataUrl(scale);
        link.click();
    }
    getCropInfo() {
        return {
            originalWidth: this.img.naturalWidth,
            originalHeight: this.img.naturalHeight,
            imgWidth: this.imgWidth,
            imgHeight: this.imgHeight,
            x: this.netPanningX,
            y: this.netPanningY
        };
    }
}
const $d6f89a2e975a62e2$var$cr = new $d6f89a2e975a62e2$export$f43653f9482b7473({});
function $d6f89a2e975a62e2$export$24422be91ad4011f(...arg) {
    $d6f89a2e975a62e2$var$cr.download(...arg);
}
function $d6f89a2e975a62e2$export$8b9478f6e9a8eb10(...arg) {
    $d6f89a2e975a62e2$var$cr.loadCanvas(...arg);
}
function $d6f89a2e975a62e2$export$7dc0d71d95f22484(...arg) {
    $d6f89a2e975a62e2$var$cr.loadImageFromUrl(...arg);
}
function $d6f89a2e975a62e2$export$eddf944f3870013a(...arg) {
    $d6f89a2e975a62e2$var$cr.loadSlider(...arg);
}
function $d6f89a2e975a62e2$export$d947e5f4f4c48d48(...arg) {
    $d6f89a2e975a62e2$var$cr.move(...arg);
}
function $d6f89a2e975a62e2$export$2f2ed3da8dfc342e(...arg) {
    $d6f89a2e975a62e2$var$cr.getCropInfo(...arg);
}
function $d6f89a2e975a62e2$export$4631f9310db9e583(...arg) {
    $d6f89a2e975a62e2$var$cr.getDataUrl(...arg);
}


const $f48faaaa69d5f8de$var$cr = new (0, $d6f89a2e975a62e2$export$f43653f9482b7473)({
    imageUrl: (0, {}),
    canvas: document.getElementById('canvas'),
    rangeInput: document.getElementById('myRange')
});
//
const $f48faaaa69d5f8de$var$filePicker = document.getElementById('filePicker');
$f48faaaa69d5f8de$var$filePicker.addEventListener('change', (e)=>{
    const file = $f48faaaa69d5f8de$var$filePicker.files?.[0];
    if (!file) return;
    const fr = new FileReader();
    fr.onload = ()=>$f48faaaa69d5f8de$var$cr.loadImageFromUrl(String(fr.result));
    fr.readAsDataURL(file);
});
/* -------------------------------------------------------------------------- */ /*                                    page                                    */ /* -------------------------------------------------------------------------- */ const $f48faaaa69d5f8de$var$dropdown = document.getElementById('dropdown');
document.getElementById('menu').addEventListener('click', ()=>{
    $f48faaaa69d5f8de$var$dropdown.classList.toggle('hidden');
});
document.getElementById('download').addEventListener('click', ()=>{
    $f48faaaa69d5f8de$var$cr.download();
});


//# sourceMappingURL=docsSrc.bb48e6a2.js.map
